/* unplugin-vue-components disabled */import { render } from "./member_record.vue?vue&type=template&id=4ff7b064&scoped=true"
import script from "./member_record.vue?vue&type=script&lang=js"
export * from "./member_record.vue?vue&type=script&lang=js"

import "./member_record.vue?vue&type=style&index=0&id=4ff7b064&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff7b064"]])

export default __exports__